import { config } from "../../config";

// Reports and exports live in the new admin (heapsgo-admin-web). The old
// reports URL stays as a signpost that points there.
export const heapsGoAdminReportsUrl = (organizationKeyName: string) =>
  `${config.heapsGoAdminUrl}/hgo/${organizationKeyName}/reports`;
